import { Grid } from "@mui/material";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import PropTypes from "prop-types";
import { terms } from "./searchOptions/searchOptions";
import { Chart } from "react-google-charts";
import {
  is_search_year_2_years_ago,
  is_search_year_current_year,
  is_search_year_last_year,
} from "./utils";

function getPieChartOptions(year) {
  return {
    title: "Porciento Participación Por Empresas. Año: " + year,
    description: "Porciento de participación en el mercado",
    is3D: false,
    pieHole: 0.3,
    pieSliceText: "percentage",
    legend: {
      position: "right",
      textStyle: { color: "black", fontSize: 10 },
      alignment: "center",
    },
    chartArea: { left: "20", right: "20" },
  };
}

function getLineChartsLabels(data) {
  return data.map((elem) => {
    return elem.company;
  });
}

function reverseDataPerYear(data, year, oneYearAgo, twoYearsAgo) {
  let result = [];

  result.push({
    label: year,
    color: "primary",
    data: data.map((e) => e.detailYear),
  });

  result.push({
    label: oneYearAgo,
    color: "success",
    data: data.map((e) => e.detailOneYearAgo),
  });

  result.push({
    label: twoYearsAgo,
    color: "info",
    data: data.map((e) => e.detailTwoYearAgo),
  });

  return result;
}

export function MarketAnalysisCharts({ data, params }) {
  // :param data = [{
  //   "presentation": "PRONACA",
  //   "company": "PRONACA",
  //   "companyId": 3907,
  //   "detailYear": 3186075,
  //   "detailOneYearAgo": 2882799,
  //   "detailTwoYearAgo": 109248,
  //   "participationYear": 39,
  //   "participationOneYearAgo": 34,
  //   "participationTwoYearAgo": 2,
  //   "growthRateYear": 0,
  //   "growthRateOneYearAgo": 2500,
  //   "detailFirstQuarter": 3186075,
  //   "detailSecondQuarter": 3112533,
  //   "detailThirdQuarter": 0,
  //   "detailFourthQuarter": 0
  // }]

  let year;
  let one_year_ago;
  let two_years_ago;

  if (is_search_year_current_year(params.year)) {
    year = Number(params.year);
    one_year_ago = year - 1;
    two_years_ago = year - 2;
  }

  if (is_search_year_last_year(params.year)) {
    year = Number(params.year);
    one_year_ago = year + 1;
    two_years_ago = year - 1;
  }

  if (is_search_year_2_years_ago(params.year)) {
    year = Number(params.year);
    one_year_ago = year + 1;
    two_years_ago = year + 2;
  }

  return (
    <div>
      <Grid container spacing={2} style={{ marginBottom: "10px" }} lg>
        <Grid item lg>
          <GradientLineChart
            icon={{ color: "info", component: "leaderboard" }}
            title="Empresas periodo de tres años"
            description={terms.filter((elem) => elem.id === params.selectedTerms).pop().name}
            chart={{
              labels: getLineChartsLabels(data),
              datasets: reverseDataPerYear(data, year, one_year_ago, two_years_ago),
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginBottom: "10px" }}>
        <Grid item md={4}>
          <Chart
            chartType="PieChart"
            data={[["Empresa", "Participacion"]].concat(
              data.map((elem) => {
                return [
                  "company" in elem ? elem.company : elem.presentation,
                  elem.participationYear,
                ];
              })
            )}
            options={getPieChartOptions(year)}
            width={"100%"}
            height={"500px"}
          />
        </Grid>
        <Grid item md={4}>
          <Chart
            chartType="PieChart"
            data={[["Empresa", "Participacion"]].concat(
              data.map((elem) => {
                return [
                  "company" in elem ? elem.company : elem.presentation,
                  elem.participationOneYearAgo,
                ];
              })
            )}
            options={getPieChartOptions(one_year_ago)}
            width={"100%"}
            height={"500px"}
          />
        </Grid>
        <Grid item md={4}>
          <Chart
            chartType="PieChart"
            data={[["Empresa", "Participacion"]].concat(
              data.map((elem) => {
                return [
                  "company" in elem ? elem.company : elem.presentation,
                  elem.participationTwoYearAgo,
                ];
              })
            )}
            options={getPieChartOptions(two_years_ago)}
            width={"100%"}
            height={"500px"}
          />
        </Grid>
      </Grid>
    </div>
  );
}

MarketAnalysisCharts.defaultProps = {
  data: [],
  params: {},
};

MarketAnalysisCharts.propTypes = {
  data: PropTypes.array,
  params: PropTypes.object,
};
